module.exports = __webpack_public_path__ + "static/media/Farma Pasa - Pustoparan - 11 Farma Pasa - Koja je ura.dd45d2e9.mp3";